import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import FormTable from '../../common/Form/Table';
import Input from '../../common/Form/Input';
import Checkbox from '../../common/Form/Checkbox';
import DatePicker from '../../common/Form/DatePicker';
import { TotalCard } from './TotalCard';
import AssetType from '../Inputs/AssetType';
import Categories from '../Inputs/Categories';
import { actualValueForDropdown } from '../../utils/common';
import moment from 'moment';

export const QuotesCard = ({ quotesArrayName }) => {
    const { watch } = useFormContext();
    const [isRecurringSelected, setIsRecurringSelected] = useState({});

    const tableSchema = {
        table: [
            {
                head: {
                    thClassName: `w-80 truncate pl-1`,
                    headName: `Asset Type`,
                    render: (headName) => {
                        return (
                            <div className='flex gap-2'>
                                {headName}
                                <span className='text-scogoorange'>*</span>
                            </div>
                        );
                    },
                },
                body: {
                    bodyClassName: `w-80 break-all pl-2`,
                    render: (_, { rowIndex }) => {
                        return <AssetType org_id={actualValueForDropdown(watch('customer'))} name={`${quotesArrayName}[${rowIndex}].asset_type`} required />;
                    },
                },
            },
            {
                head: { thClassName: `w-80 truncate`, headName: `Category` },
                body: {
                    bodyClassName: `w-80 break-all`,
                    render: (_, { rowIndex }) => {
                        return <Categories name={`${quotesArrayName}[${rowIndex}].category`} required />;
                    },
                },
            },
            {
                head: {
                    thClassName: `w-24`,
                    headName: 'Recurring',
                },
                body: {
                    bodyClassName: `truncate w-24`,
                    render: (quote, { rowIndex }) => {
                        if (quote.isEditable) {
                            return (
                                <Checkbox
                                    type='checkbox'
                                    name={`${quotesArrayName}[${rowIndex}].is_recurring`}
                                    onChange={(event) => {
                                        setIsRecurringSelected((prevState) => ({ ...prevState, [rowIndex]: event.target.checked }));
                                    }}
                                />
                            );
                        } else {
                            return <div>{quote.is_recurring ? 'Yes' : 'No'}</div>;
                        }
                    },
                },
            },
            {
                head: {
                    thClassName: `w-44`,
                    headName: 'End Date',
                },
                body: {
                    bodyClassName: `truncate w-44`,
                    render: (quote, { rowIndex }) => {
                        if (quote.isEditable) {
                            return <DatePicker padding='py-0 px-0' name={`${quotesArrayName}[${rowIndex}].end_date`} placeholder='End Date' readOnly={!isRecurringSelected[rowIndex]} />;
                        } else {
                            return <div>{quote.end_date && moment(quote.end_date).format('DD MMM YYYY')}</div>;
                        }
                    },
                },
            },
            {
                head: { thClassName: `w-80 truncate`, headName: `Description` },
                body: {
                    bodyClassName: `w-80 break-all`,
                    render: (_, { rowIndex }) => {
                        return <Input name={`${quotesArrayName}[${rowIndex}].description`} />;
                    },
                },
            },
            {
                head: {
                    thClassName: `w-60 truncate`,
                    headName: `Quantity`,
                    render: (headName) => {
                        return (
                            <div className='flex gap-2'>
                                {headName}
                                <span className='text-scogoorange'>*</span>
                            </div>
                        );
                    },
                },
                body: {
                    bodyClassName: `w-60 break-all`,
                    render: (_, { rowIndex }) => {
                        return <Input required name={`${quotesArrayName}[${rowIndex}].quantity`} type='number' />;
                    },
                },
            },
            {
                head: {
                    thClassName: `w-80 truncate`,
                    headName: `Unit Price`,
                    render: (headName) => {
                        return (
                            <div className='flex gap-2'>
                                {headName}
                                <span className='text-scogoorange'>*</span>
                            </div>
                        );
                    },
                },
                body: {
                    bodyClassName: `w-80 break-all`,
                    render: (_, { rowIndex }) => {
                        return (
                            <>
                                <Input
                                    className='grow'
                                    style={{ minWidth: '20%' }}
                                    name={`${quotesArrayName}[${rowIndex}].unit_price`}
                                    placeholder='Quotes'
                                    type='number'
                                    required
                                    step={'any'}
                                />
                            </>
                        );
                    },
                },
            },
            {
                head: {
                    thClassName: `w-36 truncate`,
                    headName: `Delete`,
                    render: (headName) => headName,
                },
                body: {
                    bodyClassName: `w-36 break-all`,
                    render: (_, { rowIndex, remove }) => {
                        if (!_.isDeleteable) {
                            return null;
                        }
                        return (
                            <>
                                <span
                                    onClick={(e) => {
                                        e.preventDefault();
                                        remove(rowIndex);
                                    }}
                                    className={`select-none material-icons text-scogoToastDangerIcon cursor-pointer hover:text-scogoprimary`}
                                >
                                    delete
                                </span>
                            </>
                        );
                    },
                },
            },
        ]
    };

    return (
        <div className={`border bg-white rounded-lg shadow-lg`}>
            <FormTable
                isLoading={false}
                schema={tableSchema}
                name={quotesArrayName}
                allowAdd={true}
                rowGenerator={() => ({ id: `${Math.random()}`, isEditable: true, isDeleteable: true })}
                buttonDivClass='px-4 py-2'
                formTableClass=''
                tableHeadFontSize='text-font11 font-medium text-black py-2'
                tableHeadClass='md:flex tableHeader hidden px-3 z-30 border-b-2 justify-between block items-center bg-scogof8'
            />
            <TotalCard quotesArrayName={quotesArrayName} />
        </div>
    );
};
